import * as React from 'react'

import { Site } from '../../../../../common/constants/siteList'
import { ILocationParams } from '../../../../../common/reducers/reactRouterLocation'
import * as styles from './filterProperties.module.css'

import FilterBoolean from '../filterBoolean'

interface IProps {
  alphaCount: number
  loopedCount: number
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const FilterProperties = ({
  alphaCount,
  loopedCount,
  locationParams,
  makeSearchLink
}: IProps) => {
  return (
    <div className={styles.root}>
      {alphaCount > 0 && (
        <FilterBoolean
          type="alpha"
          label="Alpha channel"
          count={alphaCount}
          locationParams={locationParams}
          makeSearchLink={makeSearchLink}
        />
      )}
      {loopedCount > 0 && (
        <FilterBoolean
          type="looped"
          label="Looped"
          count={loopedCount}
          locationParams={locationParams}
          makeSearchLink={makeSearchLink}
        />
      )}
    </div>
  )
}

export default FilterProperties
